<template>
  <configuration-menu-name
    title="Format und Bindung"
    :menu="menu"
    max="255"
    @update:data="$emit('update:menu', $event)"
  >
    <p>Wählen Sie nun das Format und die Bindung Ihrer Gastrokarte.</p>
  </configuration-menu-name>
  <base-box title="Bindung">
    <p>
      Wählen Sie nun zwischen Klammerheftung, Ringbindung und einem Faltflyer. Bei der Ringbindung haben Sie die Auswahl von 4 unterschiedlichen Farben.
    </p>
    <div class="cards row g-3 d-flex justify-content-start align-items-stretch">
      <label
        v-if="
          menu.attributes.compatible_formats.includes('A4') ||
          menu.attributes.compatible_formats.includes('A5') ||
          menu.attributes.compatible_formats.includes('DL')
        "
        class="col-auto col-xxl-2 cursor-pointer"
      >
        <input
          type="radio"
          name="binding"
          value="clip"
          :checked="menu.attributes.data?.binding == 'clip'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-clip.png"
          title="Klammerheftung"
          subtitle="Seiten: 8,12,16,20"
        ></base-card-compact>
      </label>
      <label
        v-if="
          menu.attributes.compatible_formats.includes('A4') ||
          menu.attributes.compatible_formats.includes('A5') ||
          menu.attributes.compatible_formats.includes('DL')
        "
        class="col-auto col-xxl-2 cursor-pointer"
      >
        <input type="radio" name="binding" value="wireo-red" :checked="isWiredSelected" @change="changeMenuData" />
        <base-card-compact image="/images/binding-wireo-black.png" title="Ringbindung" subtitle="Seiten: 6,8,10,...,40">
        </base-card-compact>
      </label>
      <label
        v-if="
          menu.attributes.compatible_formats.includes('A4') ||
          menu.attributes.compatible_formats.includes('A5') ||
          menu.attributes.compatible_formats.includes('DL')
        "
        class="col-auto col-xxl-2 cursor-pointer"
      >
        <input
          type="radio"
          name="binding"
          value="folded"
          :checked="menu.attributes.data?.binding == 'folded'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-folded.png"
          title="Faltblatt 4 Seiten"
          subtitle="Seiten: 4"
        ></base-card-compact>
      </label>
      <label v-if="menu.attributes.compatible_formats.includes('SP')" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="binding"
          value="sixpager"
          :checked="menu.attributes.data?.binding == 'sixpager'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-sixpager.png"
          title="Faltflyer 6 Seiten"
          subtitle="Seiten: 6"
          contain="true"
        ></base-card-compact>
      </label>
    </div>
  </base-box>
  <base-box v-if="isWiredSelected" title="Spiralfarbe">
    <p>Wählen sie für die Ringbindung eine der 4 unterschiedlichen Drahtfarben.</p>
    <div class="cards row g-3 d-flex justify-content-start align-items-stretch">
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="wired"
          value="wireo-red"
          :checked="menu.attributes.data?.binding == 'wireo-red'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-wireo-red.png"
          title="Ringbindung rot"
          subtitle="Seiten: 6,8,10,...,40"
        >
        </base-card-compact>
      </label>
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="wired"
          value="wireo-black"
          :checked="menu.attributes.data?.binding == 'wireo-black'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-wireo-black.png"
          title="Ringbindung schwarz"
          subtitle="Seiten: 6,8,10,...,40"
        >
        </base-card-compact>
      </label>
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="wired"
          value="wireo-silver"
          :checked="menu.attributes.data?.binding == 'wireo-silver'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-wireo-silver.png"
          title="Ringbindung silber"
          subtitle="Seiten: 6,8,10,...,40"
        >
        </base-card-compact>
      </label>
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="wired"
          value="wireo-white"
          :checked="menu.attributes.data?.binding == 'wireo-white'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/binding-wireo-white.png"
          title="Ringbindung weiß"
          subtitle="Seiten: 6,8,10,...,40"
        >
        </base-card-compact>
      </label>
    </div>
  </base-box>
  <base-box v-if="menu.attributes.data?.binding != null" title="Format">
    <p v-if="menu.attributes.data?.binding != 'sixpager'">
        Wählen Sie aus 3 unterschiedlichen Formaten die gewünschte Größe Ihrer Gastrokarte aus.
    </p>
    <div class="cards row g-3 d-flex justify-content-start align-items-stretch">
      <label v-if="menu.attributes.compatible_formats.includes('A4') && menu.attributes.data?.binding != 'sixpager'" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="format"
          value="A4"
          :checked="menu.attributes.data?.format == 'A4'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/cc-a4.jpg"
          customheight="8rem"
          customwidth="calc(8rem * 0.707)"
          title="Din A4"
          subtitle="297 x 210 mm"
        >
        </base-card-compact>
      </label>
      <label v-if="menu.attributes.compatible_formats.includes('A5') && menu.attributes.data?.binding != 'sixpager'" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="format"
          value="A5"
          :checked="menu.attributes.data?.format == 'A5'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/cc-a4.jpg"
          customheight="calc(8rem * 0.707)"
          customwidth="calc(8rem * 0.707 * 0.707)"
          title="Din A5"
          subtitle="210 x 149 mm"
        >
        </base-card-compact>
      </label>
      <label v-if="menu.attributes.compatible_formats.includes('DL') && menu.attributes.data?.binding != 'sixpager'" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="format"
          value="DL"
          :checked="menu.attributes.data?.format == 'DL'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/cc-a4.jpg"
          customheight="calc(8rem * 0.707)"
          customwidth="calc(8rem * 0.353)"
          title="Din Lang"
          subtitle="210 x 105 mm"
        >
        </base-card-compact>
      </label>
      <label v-if="menu.attributes.compatible_formats.includes('SP') && menu.attributes.data?.binding == 'sixpager'" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="format"
          value="SP"
          :checked="menu.attributes.data?.format == 'SP'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/cc-a4.jpg"
          customheight="calc(8rem * 0.707)"
          customwidth="calc(8rem * 0.353)"
          title="6-Seiter"
          subtitle="210 x 99 mm"
        >
        </base-card-compact>
      </label>
    </div>
  </base-box>
  <base-box v-if="menu.attributes.format_id != null" title="Cellophanierung">
    <p>Wählen Sie die gewünschte Cellophanierung ihrer Gastrokarte. Alle Seiten werden cellophaniert.</p>
    <div class="cards row g-3 d-flex justify-content-start align-items-stretch">
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="lamination"
          value="matte"
          :checked="menu.attributes.data?.lamination == 'matte'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/matte.png"
          title="matt"
          customwidth="calc(8rem * 0.707)"
          :subtitle="menu.attributes.data?.format == 'SP' ? 'maximale Auflage 300 Stk.' : null"
        >
        </base-card-compact>
      </label>
      <label class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="lamination"
          value="glossy"
          :checked="menu.attributes.data?.lamination == 'glossy'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/glossy.png"
          title="glänzend"
          customwidth="calc(8rem * 0.707)"
          :subtitle="menu.attributes.data?.format == 'SP' ? 'maximale Auflage 300 Stk.' : null"
        >
        </base-card-compact>
      </label>
      <label v-if="menu.attributes.data?.format == 'SP'" class="col-auto col-xxl-2 cursor-pointer">
        <input
          type="radio"
          name="lamination"
          value="none"
          :checked="menu.attributes.data?.lamination == 'none'"
          @change="changeMenuData"
        />
        <base-card-compact
          image="/images/no-lamination.png"
          title="Ohne Cellophanierung"
          customwidth="calc(8rem * 0.707)"
          :subtitle="menu.attributes.data?.format == 'SP' ? 'ab 400 Stk erhältlich' : null"
        ></base-card-compact>
      </label>
    </div>
  </base-box>
</template>

<script>
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';

import ConfigurationMenuName from '@/components/ConfigurationMenuName';

export default {
  components: {
    ConfigurationMenuName,
  },
  props: {
    menu: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:menu'],
  setup(props, { emit }) {
    const menu = useVModel(props, 'menu', emit);

    const changeMenuData = (param) => {
      let name = param.target.getAttribute('name') == 'wired' ? 'binding' : param.target.getAttribute('name');

      menu.value = {
        data: {
          [name]: param.target.value,
        },
      };
    };

    const isWiredSelected = computed(() => {
      return props.menu.attributes?.data?.binding?.startsWith('wireo-') || false;
    });

    return { changeMenuData, isWiredSelected };
  },
};
</script>

<style lang="scss" scoped></style>
